import React, { Component } from 'react';
import dusty from './cat-dusty-sm.jpg';
import gigi from './cat-gigi-sm.jpg';
import LightboxTrigger from '../LightboxTrigger/LightboxTrigger';

class Cats extends Component {

  render() {

    const images = ["/images/cats/cat-dusty.jpg", "/images/cats/cat-gigi.jpg"];
    const captions = ["Dusty", "GiGi"];
    
    return (
        <div className="cats-outer">
            <div className="cats">
                <LightboxTrigger 
                    outerClass="inline"
                    buttonClass="transparent"
                    index={0}
                    images={images}
                    captions={captions}
                >
                    <img src={dusty} alt="Dusty"/>
                </LightboxTrigger>
                <span>SLA Office Helpers</span>
                <LightboxTrigger 
                    outerClass="inline"
                    buttonClass="transparent"
                    index={1}
                    images={images}
                    captions={captions}
                >
                <img src={gigi} alt="Gigi"/>
                </LightboxTrigger>
            </div>
        </div>
    );
  }
}

export default Cats;



// WEBPACK FOOTER //
// ./src/components/Cats/Cats.js